import React from 'react';

import { Row, Col } from 'reactstrap';
import { UpwardAdvancedLoader } from 'ui';

const rowStyle = {
   height: '60vh',
   alignItems: 'center',
};

const divStyle = {
   width: '175px',
};

const UpwardPageLoader = () => {
   return (
      <Row style={rowStyle}>
         <Col>
            <div
               className='offset-5'
               style={divStyle}
            >
               <UpwardAdvancedLoader size='120'/>
            </div>
         </Col>
      </Row>
   );
};

export default UpwardPageLoader;
